import * as Yup from 'yup'

import required from '@galo-monitor/forms/validators/required.validator'

const cultivarSchema = ({ t }) => Yup.object().shape({
  name: required({ t })(Yup.string()),
  culture_id: required({ t })(Yup.string()),
  breeder_name: required({ t })(Yup.string())
})

export default cultivarSchema
